import $ from 'jquery';

$(document).ready(() => {
    const newsType = $('#news_type');

    const changeHandler = function () {
        const baseUrl = newsType.parent().attr('action');
        const finalUrl = '?type=' + newsType.val()
        window.location = finalUrl;
    };

    newsType.on('change', changeHandler);
});
